// DO NOT EDIT -- generated from fs/services/alexa/suggest/omnisuggest.proto

import * as segment from '../../../api/segment';

export enum SuggestionGroupType {
  SUGGESTION_GROUP_TYPE_INVALID = 0,
  SUGGESTION_GROUP_TYPE_ENGAGEMENT = 1,
  SUGGESTION_GROUP_TYPE_FIXIT = 2,
  SUGGESTION_GROUP_TYPE_HELP = 3,
  SUGGESTION_GROUP_TYPE_INBOUND = 4,
  SUGGESTION_GROUP_TYPE_LOCATION = 5,
  SUGGESTION_GROUP_TYPE_META = 6,
  SUGGESTION_GROUP_TYPE_NAVIGATION = 7,
  SUGGESTION_GROUP_TYPE_SENTIMENT = 8,
  SUGGESTION_GROUP_TYPE_USAGE = 9,
  SUGGESTION_GROUP_TYPE_USER = 10,
  SUGGESTION_GROUP_TYPE_PERFORMANCE = 11,
  SUGGESTION_GROUP_TYPE_CUSTOM_EVENTS = 12,
  SUGGESTION_GROUP_TYPE_DEFINED_EVENTS = 13,
  SUGGESTION_GROUP_TYPE_DASHBOARDS = 14,
  SUGGESTION_GROUP_TYPE_SEGMENTS = 15,
  SUGGESTION_GROUP_TYPE_RECENT = 16,
  SUGGESTION_GROUP_TYPE_METRICS = 17,
  SUGGESTION_GROUP_TYPE_PAGE_PROPERTIES = 18,
  SUGGESTION_GROUP_TYPE_FUNNELS = 19,
  SUGGESTION_GROUP_TYPE_NAMED_ELEMENTS = 20,
  SUGGESTION_GROUP_TYPE_PAGES = 21,
  SUGGESTION_GROUP_TYPE_TOP_SCORES = 22,
  SUGGESTION_GROUP_TYPE_JOURNEYS = 23,
  SUGGESTION_GROUP_TYPE_HEATMAPS = 24,
  SUGGESTION_GROUP_TYPE_RETENTIONS = 25,
  SUGGESTION_GROUP_TYPE_MOST_RELEVANT = 26
}

export enum SuggestionContext {
  SUGGESTION_CONTEXT_INVALID = 0,
  SUGGESTION_CONTEXT_EVENT = 1,
  SUGGESTION_CONTEXT_EVENT_DEPENDENT = 2,
  SUGGESTION_CONTEXT_USER = 3
}

export interface SuggestionGroup {
  type: SuggestionGroupType;
  suggestions: Suggestion[];
}

export enum SuggestionType {
  SUGGESTION_TYPE_INVALID = 0,
  SUGGESTION_TYPE_HELP = 1,
  SUGGESTION_TYPE_FIELD = 2,
  SUGGESTION_TYPE_CRITERIA = 3,
  SUGGESTION_TYPE_NAV = 4
}

export interface Suggestion {
  type: SuggestionType;
  helpSuggestion?: HelpSuggestion | null;
  fieldSuggestion?: FieldSuggestion | null;
  criteriaSuggestion?: CriteriaSuggestion | null;
  navSuggestion?: NavSuggestion | null;
}

export namespace Suggestion {
  export enum suggestion {
    helpSuggestion = 2,
    fieldSuggestion = 3,
    criteriaSuggestion = 4,
    navSuggestion = 5
  }

  export function suggestion_oneof(m: Suggestion): { opt: suggestion.criteriaSuggestion, val: CriteriaSuggestion } | { opt: suggestion.fieldSuggestion, val: FieldSuggestion } | { opt: suggestion.helpSuggestion, val: HelpSuggestion } | { opt: suggestion.navSuggestion, val: NavSuggestion } | null {
    if (m.helpSuggestion != null) { return { opt: suggestion.helpSuggestion, val: m.helpSuggestion } }
    if (m.fieldSuggestion != null) { return { opt: suggestion.fieldSuggestion, val: m.fieldSuggestion } }
    if (m.criteriaSuggestion != null) { return { opt: suggestion.criteriaSuggestion, val: m.criteriaSuggestion } }
    if (m.navSuggestion != null) { return { opt: suggestion.navSuggestion, val: m.navSuggestion } }
    return null;
  }
}

export interface HelpSuggestion {
  link: string;
  title: string;
}

export interface NavSuggestion {
  link: string;
  title: string;
  type: NavSuggestionType;
}

export enum NavSuggestionType {
  NAV_SUGGESTION_TYPE_INVALID = 0,
  NAV_SUGGESTION_TYPE_SEGMENT = 1,
  NAV_SUGGESTION_TYPE_DASHBOARD = 2,
  NAV_SUGGESTION_TYPE_METRIC = 3,
  NAV_SUGGESTION_TYPE_FUNNEL = 4,
  NAV_SUGGESTION_TYPE_JOURNEY = 5,
  NAV_SUGGESTION_TYPE_HEATMAP = 6,
  NAV_SUGGESTION_TYPE_RETENTION = 7
}

export interface FieldSuggestion {
  userFieldSuggestion?: UserFieldSuggestion | null;
  eventFieldSuggestion?: EventFieldSuggestion | null;
}

export namespace FieldSuggestion {
  export enum field_suggestion {
    userFieldSuggestion = 1,
    eventFieldSuggestion = 2
  }

  export function field_suggestion_oneof(m: FieldSuggestion): { opt: field_suggestion.eventFieldSuggestion, val: EventFieldSuggestion } | { opt: field_suggestion.userFieldSuggestion, val: UserFieldSuggestion } | null {
    if (m.userFieldSuggestion != null) { return { opt: field_suggestion.userFieldSuggestion, val: m.userFieldSuggestion } }
    if (m.eventFieldSuggestion != null) { return { opt: field_suggestion.eventFieldSuggestion, val: m.eventFieldSuggestion } }
    return null;
  }
}

export interface UserFieldSuggestion {
  userProperty: segment.UserProperty | null;
}

export interface EventFieldSuggestion {
  event: segment.Event | null;
}

export interface CriteriaSuggestion {
  userTipCriteriaSuggestion?: UserTipCriteriaSuggestion | null;
  eventCriteriaSuggestion?: EventCriteriaSuggestion | null;
}

export namespace CriteriaSuggestion {
  export enum criteria_suggestion {
    userTipCriteriaSuggestion = 1,
    eventCriteriaSuggestion = 2
  }

  export function criteria_suggestion_oneof(m: CriteriaSuggestion): { opt: criteria_suggestion.eventCriteriaSuggestion, val: EventCriteriaSuggestion } | { opt: criteria_suggestion.userTipCriteriaSuggestion, val: UserTipCriteriaSuggestion } | null {
    if (m.userTipCriteriaSuggestion != null) { return { opt: criteria_suggestion.userTipCriteriaSuggestion, val: m.userTipCriteriaSuggestion } }
    if (m.eventCriteriaSuggestion != null) { return { opt: criteria_suggestion.eventCriteriaSuggestion, val: m.eventCriteriaSuggestion } }
    return null;
  }
}

export interface UserTipCriteriaSuggestion {
  userProperties: segment.UserProperty[];
}

export interface EventCriteriaSuggestion {
  events: segment.Event[];
}
